/* eslint-disable  */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  FormControl,
  InputLabel,
  Tooltip,
  withStyles,
  Fab,
  FormHelperText,
  Zoom,
} from '@material-ui/core';
import TooltipIcon from '@material-ui/icons/InfoOutlined';
import {
  getCalculatedCharLegth,
} from 'lib/common-file-function';
import { InfoIcon } from '@phosphor-icons/react';
// import { Bold } from 'react-feather';

const useStyles = makeStyles((theme) => ({
  textDanger: {
    color: theme.palette.text.danger1,
    fontWeight: 500,
  },
  inputLabel: {
    marginRight: theme.spacing(3),
  },
  tooltipFab: {
    width: 16,
    height: 16,
    minHeight: 16,
    display: 'flex',
    backgroundColor: 'transparent',
    color: theme.palette.text.third,
    position: 'absolute',
    left: '100%',
    top: 0,
    marginLeft: 5,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  fieldWithLabelOrTooltip: {
    paddingTop: theme.spacing(2.5),
    '&.no-margin': {
      '&>label': {
        marginLeft: 0,
      },
    },
    '&>label': {
      display: 'flex',
      whiteSpace: 'nowrap',
      marginLeft: theme.spacing(0),
      //     overflow: ‘hidden’,
      fontWeight: 600,
      fontSize: 12,
      maxWidth: '100%',
    },
    '& label span.textVal': {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      // maxWidth: '280px',
      display: 'block',
      lineHeight: 'normal',
    },
  },
  tooltipFabIcon: {
    fontSize: 16,
  },
  textTrans: {
    textTransform: 'initial',
  },
  formHelperText: {
    marginLeft: 0
  }
}));

const CustomToolTip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#fff',
    color: '#000',
    maxWidth: 220,
    fontSize: 12,
  },
  arrow: {
    color: theme.palette.common.black,
  },
}))(Tooltip);

const FieldWrapper = (props) => {
  const {
    formControlClassName = '',
    label = '',
    id,
    error = '',
    required = false,
    descType,
    descText,
    toolTipPlacement = 'right',
    maxLength,
    showBothTextTypes = false,
    value,
    inputClassName,
  } = props;

  const { fieldWithLabelOrTooltip, tooltipFab, tooltipFabIcon, inputLabel, textDanger, textTrans, formHelperText } =
    useStyles();

  let helperText = '';
  let tooltip = '';
  let errorHelperText = '';

  if (descText !== undefined || descText != null) {
    if (showBothTextTypes) {
      tooltip = descText;
      helperText = getCalculatedCharLegth(maxLength, value) || "";
    } else if (
      typeof descText.toString().split(' ')[0] === 'number' &&
      descText.toString().split(' ')[0] >= 0
    ) {
      descType === 'TOOLTIP' ? (tooltip = descText) : (helperText = descText);
    } else if (
      typeof descText.toString().split(' ')[0] === 'number' &&
      descText.toString().split(' ')[0] <= 0
    ) {
      descType === 'TOOLTIP' ? (tooltip = descText) : (errorHelperText = descText);
    } else {
      descType === 'TOOLTIP' ? (tooltip = descText) : (helperText = descText);
    }
  }

  const makeFirstLetterCapFromSecondWrd = (val) => {
    return val.charAt(0).toUpperCase() + val.slice(1).toLowerCase();
  };

  const { showErrorMsg = true, subTextComponent: SubTextComponent = null } = props;
  return (
    <FormControl
      className={` ${
        label || tooltip ? `${fieldWithLabelOrTooltip} subfieldCheckbox` : ''
      } ${formControlClassName}`}
      fullWidth>
      {!label ? (
        false
      ) : (
        <>
          <InputLabel
            required={required}
            className={tooltip ? inputLabel : ''}
            shrink
            htmlFor={id}
            title={!tooltip && label}>
            <span className={`${inputClassName || ''} textVal`.trim()}>
              {label.split(' ').length <= 3 ? label : makeFirstLetterCapFromSecondWrd(label)}
            </span>
            {!tooltip ? (
              false
            ) : (
              <CustomToolTip
                TransitionComponent={Zoom}
                title={tooltip}
                interactive
                placement={toolTipPlacement}
                arrow>
                <Fab size="small" className={tooltipFab}>
                  <InfoIcon weight="bold" className={tooltipFabIcon} />
                </Fab>
              </CustomToolTip>
            )}
          </InputLabel>
          {SubTextComponent && <SubTextComponent />}
        </>
      )}
      {props.children}

      {helperText ? <FormHelperText className={`helper ${formHelperText}`}>{helperText}</FormHelperText> : false}
      {errorHelperText ? (
        <FormHelperText id={`${id}-help-text`} className={`${textDanger} ${formHelperText}`}>
          {errorHelperText}
        </FormHelperText>
      ) : (
        false
      )}
      {props.charHelperText ? (
        <FormHelperText className={formHelperText}>{props.charHelperText}</FormHelperText>
      ) : (
        false
      )}
      {error && showErrorMsg ? (
        <FormHelperText id={`${id}-help-text`} className={`${textDanger} ${formHelperText}`}>
          {error}
        </FormHelperText>
      ) : (
        false
      )}
    </FormControl>
  );
};

export default FieldWrapper;